import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router';
import Page from '../../components/Page/Page';
import ForgottenPasswordPage1 from './ForgottenPasswordPage1';
import ForgottenPasswordPage2 from './ForgottenPasswordPage2';
import { CognitoUser } from 'amazon-cognito-identity-js';
import { PendingAuthContext } from '../../contexts/PendingAuthContext';

const ForgottenPasswordView = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const pendingAuth = useContext(PendingAuthContext);
  const [email, setEmail] = useState<string | null>(state?.email ?? null);

  const handlePage2Submit = (user: CognitoUser, password: string) => {
    if (
      user.challengeName === 'SMS_MFA' ||
      user.challengeName === 'NEW_PASSWORD_REQUIRED'
    ) {
      pendingAuth.set({ cognitoUser: user, password });
      navigate('/login', {
        replace: true,
        state: { from: state?.from },
      });
      return;
    }

    navigate(state?.from ?? '/app', { replace: true });
  };

  return (
    <Page>
      {!Boolean(email) ? (
        <ForgottenPasswordPage1 onSubmit={setEmail} />
      ) : (
        <ForgottenPasswordPage2 email={email!} onSubmit={handlePage2Submit} />
      )}
    </Page>
  );
};

export default ForgottenPasswordView;
